<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';
import ReportsModal from '@/components/reported-content/ReportsModal';

export default {
    page: {
        title: 'Reported Content'
    },

    components: {
        ReportsModal
    },

    extends: TableView,

    data() {
        const { type = 'files' } = this.$route.query;

        return {
            pageTitle: 'Reported Content',
            activeTab: {
                value: type
            },
            actions: [
                {
                    icon: 'fas fa-sticky-note',
                    method: 'showReports'
                }
            ],
            contentId: null
        };
    },

    computed: {
        tabsElements() {
            return [
                { value: 'files', text: 'Files' },
                { value: 'comments', text: 'Comments' }
            ];
        },

        options() {
            return {
                linkSuffix: `&type=${this.activeTab.value}`,
                addButton: false
            };
        },

        labels() {
            let labels = [];

            if (this.activeTab.value === 'files') {
                labels = [
                    {
                        value: 'fileType',
                        filter: v => v.toUpperCase(),
                        width: '150px'
                    },
                    {
                        value: 'media.name',
                        text: 'File Name',
                        width: '150px'
                    },
                    { value: 'likes', type: 'number', width: '150px' },
                    {
                        value: 'user.fullName',
                        sortFieldName: 'user.firstName',
                        text: 'Creator',
                        width: '150px'
                    },
                    {
                        width: '200px',
                        text: "Creator's Campus",
                        sortable: false,
                        value: 'user.campuses',
                        filterFieldName: 'user.campuses.name',
                        filter: 'joinTable'
                    },
                    {
                        value: 'createdAt',
                        type: 'date',
                        filter: 'formatDate',
                        width: '150px'
                    }
                ];
            } else {
                labels = [
                    { value: 'details', width: '150px' },
                    {
                        value: 'user.fullName',
                        sortFieldName: 'user.firstName',
                        text: 'Author',
                        width: '150px'
                    },
                    {
                        width: '200px',
                        text: "Author's Campus",
                        sortable: false,
                        value: 'user.campuses',
                        filterFieldName: 'user.campuses.name',
                        filter: 'joinTable'
                    },
                    {
                        value: 'likes',
                        type: 'number',
                        width: '150px'
                    },
                    {
                        value: 'createdAt',
                        type: 'date',
                        filter: 'formatDate',
                        width: '150px'
                    }
                ];
            }

            return labels;
        },

        additionalFetchData() {
            return {
                isReported: true
            };
        },

        additionalComponents() {
            return [
                {
                    name: 'reports-modal',
                    props: {
                        id: this.contentId,
                        type: this.activeTab.value
                    }
                }
            ];
        }
    },

    watch: {
        activeTab() {
            this.pagination.currentPage = 1;
            this.pagination.sortBy = 'createdAt';
            this.fetchItems();
        },

        labels() {
            this.tableKey++;
        }
    },

    methods: {
        ...mapActions({
            getFiles: 'files/index',
            getComments: 'comments/index',
            deleteFile: 'files/destroy',
            deleteComment: 'comments/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/${this.activeTab.value}/${id}/edit`);
        },

        getItems(args) {
            return this.activeTab.value === 'files'
                ? this.getFiles(args)
                : this.getComments(args);
        },

        deleteItem(args) {
            return this.activeTab.value === 'files'
                ? this.deleteFile(args)
                : this.deleteComment(args);
        },

        showReports(id) {
            this.contentId = id;

            this.$bvModal.show('reports-modal');
        }
    }
};
</script>
